<template>
  <div>
    <el-dialog
      left
      title="Share Document"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      style="margin: 0 auto;"
      :visible.sync="modalShow"
      @close="sharingNote='';tags=[];refreshForm=false"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            v-if="refreshForm"
            :state="state"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            tag-pills
            add-on-change
            :tag-validator="tagValidator"
            @tag-state="onTagState"
            separator=","
          ></b-form-tags>
        </b-form-group>
        <div>Notes</div>
        <textarea
          placeholder="Note"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="edit-company-action-button-row py-3" style="margin:0px">
          <button
            type="button"
            @click="modalShow= !modalShow"
            class="todo-form-cancel-button btn-outline-secondary"
          >Cancel</button>
          <button
            type="button"
            @click.prevent="sendEmail"
            :disabled="emailCheck || submit"
            class="btn btn-info btn-fill btn-wd"
            style="height: 35px;"
          >
            Send
            <b-spinner v-if="submit" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../../../axios_api";
import { Dialog } from "element-ui";
import { Select, Option } from "element-ui";
export default {
  name: "shareDocument",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      refreshForm: Boolean
    }
  },
  watch: {
    tags(newVal, oldVal) {
      // Set the dirty flag on first change to the tags array
      this.dirty = true;
    }
  },
  computed: {
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    modalShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      }
    },
    refreshForm: {
      get() {
        return this.value.refreshForm;
      },
      set(value) {
        this.value.refreshForm = value;
      }
    }
  },
  data() {
    return {
      sharingNote: "",
      tags: [],
      dirty: false,
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      submit: false
    };
  },
  methods: {
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    sendEmail() {
      this.submit = true;
      let data = JSON.parse(JSON.stringify(this.value.data));
      data.emails = this.tags;
      data.sharingNote = this.sharingNote;
      data.account = this.$route.params.account_id;
      api
        .post("/shareDocument", { encrypt: { data: data } })
        .then(response => {
          this.$toaster.success("Email will be sent shortly...");
          this.submit = false;
          this.modalShow = false;
          this.tags = [];
        })
        .catch(error => {
          this.$toaster.error("fail to sent");
          console.log("error in sending email", error);
        });
    }
  }
};
</script>